import React from 'react';
import PropTypes from 'prop-types';
import dateUtils from 'helpers/dateUtils';
import styled from 'styled-components';
import translate from 'components/hoc/translate';

const TimeFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Time = styled.div`
    font-size: 16px;
    line-height: 1.2;
    text-transform: capitalize;
`;

const TimeField = (props) => {
    const {
        label,
        translate,
        value,
    } = props;

    return (
        <TimeFieldWrapper>
            { label &&
                <Label>{ translate(label) }</Label>
            }

            <Time>{ dateUtils.formatTimeFromString(value) }</Time>
        </TimeFieldWrapper>
    );
};

TimeField.propTypes = {
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default translate(TimeField);



// WEBPACK FOOTER //
// ./src/components/show/TimeField.js